import { z } from 'zod';
const TrustFundSweepRoleSchema = z.enum([
    'INTEREST', 'CHARGE', 'SPLIT_CHARGE', 'FUND_REFUND', 'VAT_REDIRECT', 'SWEEP',
]);
export const CheckTrustFundSweepsInputSchema = z.object({
    bankAccountId: z.string().uuid(),
    cursor: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/).optional(),
    limit: z.number().int().min(1).max(100).optional(),
    candidateCycles: z.array(z.object({
        bankAccountId: z.string().uuid(),
        interestMonth: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
        members: z.array(z.object({
            lineId: z.string().uuid(),
            role: TrustFundSweepRoleSchema,
            pairedLineId: z.string().uuid().optional(),
        }).strict()).min(1).max(500),
    }).strict()).max(500),
}).strict();
export const CheckTrustFundSweepsResponseSchema = z.object({
    verdicts: z.array(z.object({
        bankAccountId: z.string().uuid(),
        statutoryType: z.enum(['S86_2', 'S86_3', 'S86_4']),
        interestMonth: z.string(),
        status: z.enum(['missing', 'short', 'over']),
        owedMinorUnits: z.number().int(),
        sweptMinorUnits: z.number().int(),
        currency: z.string(),
        importedThrough: z.string(),
        graceAnchorDate: z.string(),
    })).max(100),
    nextCursor: z.string().nullable(),
});
